import module from 'cliente/module.js'
import template from './template.html'

export class ClienteInformacionAtencionAgregarComponent {
  clienteId
  agregando = false
  data = {
    nombre: '',
    apellidos: '',
    correo: '',
    notificaciones: {
      correo: false,
    },
  }

  constructor ($state) {
    this.$state = $state
  }

  aceptar (data) {
    this.agregando = false

    if (data) {
      this.$state.go('cliente.informacion.atencion')
    }
  }

  actualizarNotificaciones () {
    if (!this.data.correo) this.data.notificaciones.correo = false
  }
}

module.component('clienteInformacionAtencionAgregar', {
  controller: ClienteInformacionAtencionAgregarComponent,
  template,
  bindings: {
    clienteId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/atencion/agregar/component.js